













































import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import {
	ListItemDTO,
	ContentStreamLevelDTO,
	ContentStreamDTO,
	ContentStreamClient,
	ContentStreamDTOStatus
} from "../../Generated/ParticaAPI";

import { ContentStreamService, IContentStreamService } from "../../BusinessServices/contentstream";

import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ContentStreamLevelForm from "@/Ui-Components/ContentStream/ContentStreamLevelForm.vue";
import ContentStreamLevelList from "@/Ui-Components/ContentStream/ContentStreamLevelList.vue";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaCardFill from "@/Ui-Components/Common/Container/ParticaCardFill.vue";
import ParticaDialogCard from "@/Ui-Components/Common/Container/ParticaDialogCard.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../../Models/Buttons";
import ParticaStreamBase from "../Base/ParticaStreamBase.vue";
import { BreadcrumbItem } from "../../Models/Breadcrumb";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";


@Component({
	name: "ContentStreamLevels",
	components: {
		ContentStreamLevelForm,
		ContentStreamLevelList,
		ParticaError,
		ParticaRowContainer,
		ParticaCard,
		ParticaDialogCard,
		ParticaView,
		ParticaRightDrawer,
		ParticaCardFill,
		ButtonList
	}
})
export default class ContentStreamLevels extends ParticaStreamBase {
	private levels: ListItemDTO[] = [];
	private level: ContentStreamLevelDTO = new ContentStreamLevelDTO();
	private stream: ContentStreamDTO = new ContentStreamDTO();
	private contentStreamService: IContentStreamService;
	@Prop() private id: number;

	private newleveldialog: boolean = false;

	private levelsactions: ButtonConfig[] = [
		// init our menu for the list.
		{
			label: "Add Level",
			action: eParticaAction.CONTENT_STREAM_LEVEL_ADD,
			type: ButtonType.OK
		} as ButtonConfig,
	];

	private levelactions: ButtonConfig[] = [
		// init our menu for the list.
		{
			label: "Select",
			action: eParticaAction.CONTENT_STREAM_LEVEL_SELECT,
		} as ButtonConfig,
	];

	private levelbuttons: ButtonConfig[] = [
		{
			label: "Save",
			action: eParticaAction.CONTENT_STREAM_LEVEL_SAVE,
			type: ButtonType.OK
		} as ButtonConfig,
		{
			label: "Cancel",
			action: eParticaAction.CONTENT_STREAM_CANCEL_SAVE_LEVEL,
			type: ButtonType.Cancel
		} as ButtonConfig
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_CANCEL_SAVE_LEVEL: {
					this.newleveldialog = false;
					this.level = new ContentStreamLevelDTO();
					break;
				}
				case eParticaAction.CONTENT_STREAM_LEVEL_SAVE: {
					this.level = event.item as ContentStreamLevelDTO;
					this.level.contentStreamId = this.id;
					await this.contentStreamService.saveContentStreamLevel(this.level);
					this.ShowSnackbar("Pricing level saved.");
					this.newleveldialog = false;
					await this.init();
					break;
				}
				case eParticaAction.CONTENT_STREAM_LEVEL_SELECT: {
					this.level = await this.contentStreamService.getContentStreamLevel(event.item.id as number);
					this.newleveldialog = true;
					break;
				}
				case eParticaAction.CONTENT_STREAM_LEVEL_ADD: {
					this.level = new ContentStreamLevelDTO();
					this.newleveldialog = true;
					break;
				}
				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (e) {
			this.ShowErrorDialog(e, "An error occured handling the event.");
		} finally {
			this.LoadingEnd();
		}
	}

	private IsActive(): boolean {
		if (this.stream.status === ContentStreamDTOStatus.Active) {
			return true;
		}
		return false;
	}

	private async init() {
		try {
			this.LoadingStart();
			this.contentStreamService = this.particaServices.getContentStreamService();
			this.stream = await this.contentStreamService.getContentStream(this.id);
			this.level = new ContentStreamLevelDTO();
			this.level.id = 0;
			this.level.additionalInfo = "";
			this.level.contentStreamId = this.id;
			this.levels = await this.navigationService.getLevelsForStream(this.id);
			await this.getStreamNav(this.id);
		} catch (e) {
			this.ShowErrorDialog(e, "Error initializing.");
		} finally {
			this.LoadingEnd();
		}
	}
	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();

	}
	private async mounted() {
		this.metadata.name = "Pricing Levels";
		await this.init();
	}
}
